


<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li class="last"><span><a href="/sirang/helpdesk">Help-desk</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-1" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="portlet-column portlet-column-only" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-only" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-static portlet-static-end portlet-journal-content " id="p_p_id_56_INSTANCE_D9HFQm6d3gjn_">
                     <span id="p_56_INSTANCE_D9HFQm6d3gjn"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_D9HFQm6d3gjn">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">

                                    <table style="width: 100%;">
                                       <tbody>
                                          <tr>
                                             
                                             <td>
                                                <header class="portlet-topper gradient">
                                                   <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">
                                                      Richieste di supporto all’help desk del sira sardegna
                                                   </span> </h1>
                                                </header>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
         



                                    <div class=WordSection1>
                                       
                                       <p class=MsoNormal><span  >Per ricevere supporto
                                       nell’utilizzo dei servizi “on line” del SIRA Sardegna, è possibile contattare
                                       l’Help Desk attraverso i seguenti canali:</span></p>
                                       
                                       <p class=MsoNormal><b><span  >E-mail</span></b></p>
                                       
                                       <p class=MsoNormal><span  >La richiesta via e-mail va
                                       inviata al seguente indirizzo:</span></p>
                                       
                                       <p class=MsoNormal><span  >helpdesksira@regione.sardegna.it</span></p>
                                       
                                       <p class=MsoNormal><b><span  >Telefono</span></b></p>
                                       
                                       <p class=MsoNormal><span  >È, inoltre contattare l’Help Desk
                                       al numero di telefono 070.0997040.</span></p>
                                       
                                       <p class=MsoNormal><span  >L’Help Desk del SIRA Sardegna è
                                       operativo dal lunedì al venerdì: dalle 8.00 alle 18.00, il sabato: dalle 8.00
                                       alle 13.00</span></p>
                                       
                                       <p class=MsoNormal><b><span  >Informazioni da corredare alla
                                       richiesta</span></b></p>
                                       
                                       <p class=MsoNormal><span  >Qualsiasi comunicazione
                                       indirizzata al personale preposto del SIRA, dovrà essere corredata dei seguenti
                                       dati:</span></p>
                                       
                                       <p class=MsoListParagraph ><span 
                                       >-<span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                       </span></span><span  >generalità dell'utente (cognome, nome);</span></p>
                                       
                                       <p class=MsoListParagraph ><span 
                                       >-<span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                       </span></span><span  >struttura di appartenenza;</span></p>
                                       
                                       <p class=MsoListParagraph ><span 
                                       >-<span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                       </span></span><span  >numero telefonico e mail (se diversa da quella di invio);</span></p>
                                       
                                       <p class=MsoListParagraph ><span 
                                       >-<span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                       </span></span><span  >natura della richiesta (descrizione sommaria)</span></p>
                                       
                                       <p class=MsoNormal><span  >&nbsp;</span></p>
                                       
                                       <p class=MsoListParagraph ><span >8.<span
                                       >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
                                       >Modificare la sezione Contatti nel footer in Riferimenti</span></p>
                                       
                                       <p class=MsoNormal><span >&nbsp;</span></p>
                                       
                                       <p class=MsoListParagraph ><span >9.<span
                                       >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
                                       >Eliminare la sezione contattaci </span></p>
                                       
                                       <p class=MsoNormal><span >&nbsp;</span></p>
                                       
                                       <p class=MsoListParagraph ><span >10.<span
                                       >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
                                       >Aggiungere una sezione Dati aperti, come da ulteriore file.</span></p>
                                       
                                       <p class=MsoNormal><span >&nbsp;</span></p>
                                       
                                       </div>
                                       
                                       
                                       
                                    
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>